define('home/views/RecommendationsModuleView',[
    'underscore',
    'backbone-marionette',

    'home/views/RecommendationView',
    'home/views/UserSuggestionView',
    'home/views/ForumSuggestionView',
    'home/views/ProfileModuleEmptyView',

    'home/templates/recommendedUsersModule',
    'home/templates/recommendedForumsModule',
], function (
    _,
    Marionette,

    RecommendationView,
    UserSuggestionView,
    ForumSuggestionView,
    ProfileModuleEmptyView,

    recommendedUsersModuleTemplate,
    recommendedForumsModuleTemplate
) {
    'use strict';

    var RecommendationsModuleView = Marionette.CompositeView.extend({
        // Must be given ItemView and template options

        className: 'aside__wrap -padded',
        itemView: RecommendationView,
        emptyView: ProfileModuleEmptyView,
        itemViewContainer: '[data-role=items]',
        events: {
            'click [data-action=refresh]': 'refreshModule',
        },

        templateHelpers: function () {
            return {
                hideDiscoverLink: this.hideDiscoverLink,
            };
        },

        initialize: function (options) {
            this.collection = this.model && this.model.items;
            this.hideDiscoverLink = options && options.hideDiscoverLink;
        },

        refreshModule: function () {
            var $el = this.$el;
            $el.addClass('is-refreshing');
            var handleResetComplete = function () {
                $el.removeClass('is-refreshing');
            };
            this.model.fetchItems({ reset: true }).then(handleResetComplete);
        },
    }, {
        // Factory methods for creating 2 common RecommendationsModuleViews:
        // users and forums
        createUserRecommendedModuleView: function (options) {
            return new RecommendationsModuleView(_.extend({
                template: recommendedUsersModuleTemplate,
                itemViewOptions: {
                    RecommendedObjectView: UserSuggestionView,
                },
            }, options));
        },

        createForumRecommendedModuleView: function (options) {
            return new RecommendationsModuleView(_.extend({
                template: recommendedForumsModuleTemplate,
                itemViewOptions: {
                    RecommendedObjectView: ForumSuggestionView,
                },
            }, options));
        },
    });

    return RecommendationsModuleView;
});

